(() => {
  if (window.location.hash) return;
  let userHasInteracted = false;
  const stopPreventingScroll = () => {
    userHasInteracted = true;
    document.removeEventListener('focusin', preventInitialFormFocus, true);
    window.removeEventListener('scroll', keepPageAtTop);
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((eventName) => {
      document.removeEventListener(eventName, stopPreventingScroll, true);
    });
  };
  const keepPageAtTop = () => {
    if (!userHasInteracted && window.scrollY > 0) window.scrollTo(0, 0);
  };
  const preventInitialFormFocus = (event) => {
    if (
      userHasInteracted ||
      !event.target.matches('input, select, textarea') ||
      !event.target.closest('form')
    ) {
      return;
    }
    event.target.blur();
    keepPageAtTop();
  };
  document.addEventListener('focusin', preventInitialFormFocus, true);
  window.addEventListener('scroll', keepPageAtTop, { passive: true });
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((eventName) => {
    document.addEventListener(eventName, stopPreventingScroll, true);
  });
  window.addEventListener('pageshow', keepPageAtTop);
})(); 